import { RootState } from "../store/store";

export const selectSubscriptionData = (state: RootState) =>
  state.subscription.subscriptionData;

export const selectIsLoading = (state: RootState) =>
  state.subscription.isLoading;

export const selectError = (state: RootState) => state.subscription.error;

export const selectUserSubscription = (state: RootState) =>
  state.subscription.subscriptionData;

export const selectSubscriptionStatus = (state: RootState) =>
  state.subscription.subscriptionData?.subscriptionStatus;
